import React, { FC } from 'react';
import FormBlock from 'src/components/FormBlock';
import { OrderExpeditionPackageType } from 'src/types/orderExpeditionPackage';
import ProductsTable from './ProductsTable';
import Detail from './Detail';
import { sizes } from 'src/themes/default';
import { FormErrorsType, OnChangeType } from '../../types/global';
import { EditKeysType } from './constants';

export interface RenderComponentsPropsType {
    formRef: React.RefObject<HTMLFormElement>;
    data: OrderExpeditionPackageType | null;
    onChange: OnChangeType<EditKeysType>;
    editData: OrderExpeditionPackageType;
    editErrors: FormErrorsType;
    disableEdit: boolean;
}

const RenderComponents: FC<RenderComponentsPropsType> = (props) => {
    return (
        <>
            <form ref={props.formRef}>
                <FormBlock sx={{ marginBottom: sizes.blocks_top_MG }}>
                    <Detail
                        onChange={props.onChange}
                        editData={props.editData}
                        editErrors={props.editErrors}
                        disableEdit={props.disableEdit}
                    />
                </FormBlock>
            </form>
            <ProductsTable data={props.editData.PRODUCTS || []} />
        </>
    );
};

export default RenderComponents;
